import React from 'react';
import type { TextStyle } from 'react-native';

import { Text } from '@/components/ui';
import { createStyles } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type AuthTermsTextProps = {
  prefix: string;
  termsOfService: string;
  conjunction: string;
  privacyPolicy: string;
  /** Insert a line break after the prefix (Login layout). Default `false` (Welcome layout). */
  breakAfterPrefix?: boolean;
  onPressTermsOfService?: () => void;
  onPressPrivacyPolicy?: () => void;
  /** Extra style (e.g. `marginTop`) merged onto the paragraph. */
  style?: TextStyle;
};

const TERMS_VARIANT = 'Font Guardian App/Subtitle/Subtitle 14 Regular';

/** Legal copy with tappable Terms of Service / Privacy Policy links (Welcome + Login). */
export function AuthTermsText({
  prefix,
  termsOfService,
  conjunction,
  privacyPolicy,
  breakAfterPrefix = false,
  onPressTermsOfService,
  onPressPrivacyPolicy,
  style,
}: AuthTermsTextProps) {
  const styles = useStyles();
  return (
    <Text variant={TERMS_VARIANT} style={style ? [styles.terms, style] : styles.terms}>
      {prefix}
      {breakAfterPrefix ? '\n' : null}
      <Text
        variant={TERMS_VARIANT}
        fontWeight={'600'}
        style={styles.link}
        onPress={onPressTermsOfService}>
        {termsOfService}
      </Text>
      {conjunction}
      <Text
        variant={TERMS_VARIANT}
        fontWeight={'600'}
        style={styles.link}
        onPress={onPressPrivacyPolicy}>
        {privacyPolicy}
      </Text>
    </Text>
  );
}

const useStyles = createStyles(() => ({
  terms: {
    color: colors['10'],
    textAlign: 'center',
  },
  link: {
    color: guardianColors['Main/Main'],
  },
}));

export default AuthTermsText;
